import {observer} from "mobx-react";
import {useInjection} from "inversify-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import {
    ChipLabel,
    ChipValue,
    ClearButton,
    Container,
    HorizontalItem,
    HorizontalList,
    HorizontalRow,
    Label,
    TextEllipsis,
    Wrapper,
} from "@dropDesk/presentation/components/filters/filters_applied/styled";
import {ICONS_DROPDESK} from "@dropDesk/storage/icons/icons.d";
import DropDeskIcon from "@dropDesk/storage/icons";
import React from "react";
import {hexToRGBA} from "@dropDesk/utils/helpers/colors";

export type FilterKey =
    | "status"
    | "priority"
    | "client"
    | "attendant"
    | "userClient"
    | "sector"
    | "descriptionStatic"
    | "period"
    | "evaluationValue"
    | "listOnlySectorEmpty";

export type AppliedFilterItem = {
    key: FilterKey;
    label: string;
    value: string;
};

const FiltersApplied = observer(
    ({
         items,
         onRemoveItem,
         paddingWidth,
         onClearAll,
     }: {
        items: AppliedFilterItem[]
        onRemoveItem: (key: FilterKey) => void
        paddingWidth: number;
        onClearAll?: () => void;
    }) => {
        const appController = useInjection(AppController);
        const colors = appController.theme.colorScheme;
        const widthFilterAppliedLabel = 150;
        const containerBackground = hexToRGBA(colors.text, 0.03);

        return (
            <Wrapper>
                <Container border={colors.border} background={containerBackground}>
                    <Label color={colors.accent}>
                        Filtros aplicados:
                    </Label>
                    <HorizontalList paddingWidth={paddingWidth + widthFilterAppliedLabel}>
                        <HorizontalRow>
                            {items.map((item) => (
                                <HorizontalItem
                                    key={item.key}
                                    color={colors.text}
                                    borderColor={colors.border}
                                    backgroundColor={colors.onBackground}
                                >
                                    <TextEllipsis>
                                        <ChipLabel>{item.label}:</ChipLabel>{' '}
                                        <ChipValue>{item.value}</ChipValue>
                                    </TextEllipsis>
                                    <DropDeskIcon
                                        onClick={() => onRemoveItem(item.key)}
                                        icon={ICONS_DROPDESK.cancel}
                                        color={colors.hint}
                                        size={12}
                                        style={{marginLeft: 8, cursor: 'pointer'}}
                                    />
                                </HorizontalItem>
                            ))}
                        </HorizontalRow>
                    </HorizontalList>
                    {!!onClearAll && (
                        <ClearButton
                            type="button"
                            color={colors.accent}
                            onClick={onClearAll}
                        >
                            Limpar filtros
                        </ClearButton>
                    )}
                </Container>
            </Wrapper>
        )
    })
export default FiltersApplied;
